
import { prefectureService } from "@/services/perfectureService";
import { DEFAULT_ERROR_MESSAGE, PerfectureStore, PrefectureDto } from "@/types";
import { create } from "zustand";

export const usePerfectureStore = create<PerfectureStore>((set) => ({
  prefectures: [],
  loading: false,
  error: null,

  setLoading: (loading: boolean) => set({ loading }),
  setError: (error: string | null) => set({ error }),
  setPrefectures: (prefectures: PrefectureDto) => set({ prefectures }),
  fetchPrefectures: async () => {
    try {
      set({ loading: true });
      const prefectures = await prefectureService.getPrefectures();
      const prefecturesData = prefectures.data.map((item) => ({
        label: item.label,
        value: item.key,
      }));
      set({ prefectures: prefecturesData });
    } catch (error: any) {
      set({ error: error.message || DEFAULT_ERROR_MESSAGE });
    } finally {
      set({ loading: false });
    }
  },
  clearError: () => set({ error: null }),
  clearPrefecture: () => set({ prefectures: [] }),
  resetStore: () => set({
    prefectures: [],
    loading: false,
    error: null
  })
}));